import { render, staticRenderFns } from "./viewDialog.vue?vue&type=template&id=23417d13&scoped=true&"
import script from "./viewDialog.vue?vue&type=script&lang=js&"
export * from "./viewDialog.vue?vue&type=script&lang=js&"
import style0 from "./viewDialog.vue?vue&type=style&index=0&id=23417d13&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23417d13",
  null
  
)

export default component.exports